import { ContainerItem } from './carrieritem';
import { ErrorDetail } from './error-detail';
import { State, CarrierType, ScannerType, MaterialType } from './carrier-enum';
import { ContainerType } from '../container-view/models/container-type-enum';
import { LabMDM } from "../masterdata/models/lab";
import { OriginalMaterialType } from './sample';
import { CarrierStatus } from './CarrierStatus';

export class Carrier {
    _id: string;
    scannerType: ScannerType;
    carrierType: CarrierType;
    barcode: string;
    scanResultFileName: string;
    rackPosition: string;
    scanDate: number;
    creationDate: number;
    state: State;
    orientation: string;
    containerItems: Array<ContainerItem>;
    errors: Array<ErrorDetail>;
    isOpenForEdit: boolean;
    isDirty: boolean;
    visible: boolean;
    lab: LabMDM;
    errorCount: number;
    containerType: ContainerType;
    materialType: MaterialType;
    isSavedAfterScan: boolean;
    originalMaterialType: OriginalMaterialType;
    storageLocationOfContainer: string;
    carrierStatus: Array<CarrierStatus>;
    wellType: string;
}

export class Data {
    data: Array<Carrier>;
}



